import { useEffect } from 'react';

import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@/app/hooks';
import { DonorSchedulingActions } from '@/app/slices/donorScheduling';
import useDebounce from '@/components/hooks/useDebounce';
import { DEBOUNCE_DELAY, MIN_SEARCH_LENGTH } from '@/constants';

type QuickFilterProps = {
  value: string;
  onChange: (value: string) => void;
};

export const QuickFilter = ({ value, onChange }: QuickFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const debouncedSearch = useDebounce(value, DEBOUNCE_DELAY);

  useEffect(() => {
    dispatch({
      type: DonorSchedulingActions.UPDATE_QUICK_FILTER_TEXT,
      payload: value.length >= MIN_SEARCH_LENGTH ? debouncedSearch : '',
    });
  }, [debouncedSearch, dispatch, value]);

  return (
    <IconField iconPosition="left">
      <InputIcon className="pi pi-search" />
      <InputText
        autoFocus
        className="donor-scheduling-quick-filter"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('common.search')}
      />
    </IconField>
  );
};
